import { useEffect } from 'react';

import Placeholder from '@atlaskit/react-ufo/placeholder';
import UFOSegment from '@atlaskit/react-ufo/segment';

import { type Config, type ModalErrorFallbackProps } from './types';

const GlobalModalErrorFallback = ({ closeModal }: ModalErrorFallbackProps) => {
	useEffect(() => {
		closeModal();
	}, [closeModal]);

	return null;
};

export const defaultEntryPointConfig: Config = {
	PlaceholderComponent: Placeholder,
	UFOSegmentComponent: UFOSegment,
	GlobalModalErrorFallback,
};
